import { ScrollReveal } from '@/components/ui/scroll-reveal';
import { CountUp } from '@/components/ui/count-up';

const STATS = [
  { v: 500, s: '+', label: 'Happy Clients' },
  { v: 1000, s: '+', label: 'Jobs Crushed' },
  { v: 5, s: '★', label: 'Avg. Rating' },
  { v: 10, s: '+', label: 'Years Loud' },
];

export function Impact() {
  return (
    <section className="relative py-24 bg-charcoal-deep border-y-2 border-electric/30 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at 20% 50%, rgba(0,180,216,.15), transparent 50%), radial-gradient(circle at 80% 50%, rgba(255,214,10,.1), transparent 50%)',
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <ScrollReveal className="text-center mb-14">
          <div className="text-electric font-display tracking-[0.4em] text-xs mb-3">// THE NUMBERS</div>
          <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            IMPACT. MEASURED.
          </h2>
        </ScrollReveal>

        <ScrollReveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {STATS.map((s) => (
              <div key={s.label} className="text-center">
                <div
                  className="font-display font-bold text-electric text-7xl sm:text-8xl leading-none mb-3"
                  style={{ textShadow: '0 0 40px rgba(0,180,216,.5)' }}
                >
                  <CountUp end={s.v} suffix={s.s} />
                </div>
                <div className="h-[2px] w-12 bg-thunder mx-auto mb-3" />
                <div className="font-display text-white tracking-[0.25em] text-xs uppercase">{s.label}</div>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}
